import React from 'react';
import { IDummyProps } from './types';
import { getDndTemplate } from './templates';
import * as meta from '../../meta-data.json';

export const View = (props: IDummyProps) => {
	const dragAndDropLayout = getDndTemplate(props);
	return (
        <div data-epo={`epo-dragAndDrop-${meta.version}`}>{dragAndDropLayout}</div>
	);
};
